/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2024-01-11T10:42:57.392
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveRentHouseHoldItemHistory,
	getRentHouseHoldItemHistoryCreateInit,
	getRentHouseHoldItemHistoryEditInit,
	getRentHouseHoldItemHistoryView,
	deleteRentHouseHoldItemHistory
} from '@api/rentmanage/RentHouseHoldItemHistory';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getRentHouseHoldItemHistoryCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseHoldItemHistoryCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentHouseHoldItemHistoryEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseHoldItemHistoryEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentHouseHoldItemHistory({}, RentHouseHoldItemHistory) {
			return new Promise((resolve, reject) => {
				saveRentHouseHoldItemHistory(RentHouseHoldItemHistory)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getRentHouseHoldItemHistoryView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseHoldItemHistoryView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteRentHouseHoldItemHistory({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseHoldItemHistory({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
